import { useAuthStore } from '@/store/auth'
import { useCartStore } from '@/store/cart'

export default defineNuxtPlugin(() => {
  if (process.server) return
  const auth = useAuthStore()
  const cart = useCartStore()

  let hydratedFromFirestore = false

  async function tryHydrateFromFirestore() {
    if (!auth.user?.uid && !auth.user?.email) return
    if (!cart.hydrated || hydratedFromFirestore) return
    if (cart.hasCartItems) return
    await cart.hydrateFromFirestore(auth.user.uid || auth.user.email)
    hydratedFromFirestore = true
  }

  const stopAuth = watch(
    () => auth.hydrated,
    (val) => { if (val) tryHydrateFromFirestore() },
    { immediate: true }
  )
  const stopCart = watch(
    () => cart.hydrated,
    (val) => { if (val) tryHydrateFromFirestore() },
    { immediate: true }
  )

  watch(
    () => auth.user,
    async (user) => {
      if (user && (user.uid || user.email)) {
        await tryHydrateFromFirestore()
      } else {
        hydratedFromFirestore = false
      }
    }
  )
})
